import axios from "axios";

const axiosClient = axios.create({
  baseURL: `http://localhost:4440/api/`, // at Libas PC
  // baseURL: `https://localhost:7026/api/`,
  headers: {
    // Content-Type: application/json and Accept: application/json
    Accept: "*",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Credentials": true,
  },
});

axiosClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    let res = error.response;
    if (res.status === 401) {
      window.location.href = `http://localhost:5000/login`;
    }
    console.error("Looks like there was a problem. Status Code: " + res.status);
    return Promise.reject(error);
  }
);

// export default {
//   axiosClient
// };

export default axiosClient;
